import {
  GOT_CUSTOMER_PROFILE_DATA,
  SET_IS_LOADING_CUSTOMER_PROFILE,
  UPDATED_CUSTOMER_PROFILE_DATA,
  SAVED_NEW_CUSTOMER_DATA,
  SAVED_EDITED_CUSTOMER_DATA,
  RESET_CUSTOMER_PROFILE_FORM,
  GET_CUSTOMER_PROFILE_DATA,
  UPDATED_BOOKING_ONLY_CUSTOMER_PROFILE_DATA,
  LIMITED_PERMISSIONS
} from "../actions/customerProfile";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";

import { customerProfileInitialState } from "../state/initialState";
import { clone } from "./helper";
import objectAssign from "object-assign";

export default (state = customerProfileInitialState, action) => {
  let newStatus;
  switch (action.type) {
    case RESET_CUSTOMER_PROFILE_FORM:
      newStatus = customerProfileInitialState;
      return objectAssign({}, state, newStatus);
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        loadingCustomerProfile: false
      };
      return objectAssign({}, state, newStatus);

    case LIMITED_PERMISSIONS:
      if (action.data && !action.data.canViewCustomerProfile)
        newStatus = {
          loadingCustomerProfile: false
        };
      return objectAssign({}, state, newStatus);
    case SAVED_NEW_CUSTOMER_DATA:
    case SAVED_EDITED_CUSTOMER_DATA:
    case GOT_CUSTOMER_PROFILE_DATA: {
      if (action.data.status === "failed") {
        // TODO: display the stored error
        return objectAssign({}, state, {
          apiErrorReasons: action.data.reasons,
          loadingCustomerProfile: false
        });
      } else {
        let newCustomerProfile = clone(state.customerProfileData);
        newCustomerProfile.address = action.data.address;
        newCustomerProfile.blocked = action.data.blocked;
        newCustomerProfile.firstName = action.data.firstname;
        newCustomerProfile.noShow = action.data.noshow;
        newCustomerProfile.lastName = action.data.lastname;
        if (action.data.emails && action.data.emails.length > 0) {
          newCustomerProfile.email = (
            action.data.emails.find(x => x.primary) || {}
          ).email;
        } else {
          newCustomerProfile.email = "";
        }
        if (action.data.deleted) {
          newCustomerProfile.deleted = action.data.deleted;
        }
        if (action.data.phonenumbers && action.data.phonenumbers.length > 0) {
          newCustomerProfile.phoneNumber = (
            action.data.phonenumbers.find(x => x.primary) || {}
          ).number;
        } else {
          newCustomerProfile.phoneNumber = "";
        }
        newCustomerProfile.id = action.data.id;
        newCustomerProfile.captureCreditCard = action.data.capturecreditcard;

        return objectAssign({}, state, {
          apiCustomerProfileData: action.data,
          loadingCustomerProfile: false,
          customerProfileData: newCustomerProfile,
          gotCustomerProfileData: true
        });
      }
    }
    case UPDATED_CUSTOMER_PROFILE_DATA: {
      return objectAssign({}, state, { customerProfileData: action.data });
    }
    case UPDATED_BOOKING_ONLY_CUSTOMER_PROFILE_DATA: {
      return objectAssign({}, state, {
        bookingOnlyCustomerProfileData: action.data
      });
    }
    case GET_CUSTOMER_PROFILE_DATA:
      return objectAssign({}, state, { loadingCustomerProfile: true });
    case SET_IS_LOADING_CUSTOMER_PROFILE: {
      return objectAssign({}, state, {
        loadingCustomerProfile: action.loadingCustomerProfile
      });
    }
    default:
      return state;
  }
  return state;
};
